import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface RegularLabelsState {
  isLoading: boolean
  // Always store the raw array of key type strings
  data: string[] | null
  error: string | null
  httpStatus: number | null
}

const initialState: RegularLabelsState = {
  isLoading: false,
  data: null,
  error: null,
  httpStatus: 0
}

export const getWrapRegularLabelsSlice = createSlice({
  name: 'WrapRegularLabels',
  initialState,
  reducers: {
    regularLabelsLoadingAction: (state): RegularLabelsState => {
      return {
        isLoading: true,
        data: [],
        error: null,
        httpStatus: 0
      }
    },
    regularLabelsUpdateAction: (state, action: PayloadAction<any>): RegularLabelsState => {
      // Accept several shapes: raw array, service response object, or object with nested data/type
      const payload = action.payload.data
      let arr: string[] | null = null
      if (Array.isArray(payload)) {
        arr = payload
      } else if (Array.isArray(payload?.data)) {
        arr = payload.data
      } else if (Array.isArray(payload?.type)) {
        arr = payload.type
      }
      return {
        isLoading: false,
        data: arr,
        error: null,
        httpStatus: action.payload.httpStatus
      }
    },
    regularLabelsErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>): RegularLabelsState => ({
      isLoading: false,
      data: null,
      error: action.payload.errorMessage,
      httpStatus: action.payload.httpStatus
    })
  }
})

export const { regularLabelsLoadingAction, regularLabelsUpdateAction, regularLabelsErrorAction } = getWrapRegularLabelsSlice.actions

export default getWrapRegularLabelsSlice.reducer
